import React from 'react'
import { Redirect, useHistory, useRouteMatch } from 'react-router-dom'
import { OrderingProvider, useOrdering } from '../../context/OrderingContext'
import CheckoutForm from '../CheckoutForm/CheckoutForm'
import styles from './CheckoutPage.module.scss'

function CheckoutContent({ restaurantId, checkoutConfig }) {
	const history = useHistory()
	const { cartItems, total, clearCart } = useOrdering()
	const matchOrderId = useRouteMatch('/order/:id/checkout')
	const matchOrderMap = useRouteMatch('/order/:restaurantId/:mapId/checkout')

	if (cartItems.length === 0) {
		const menuPath = matchOrderMap
			? `/order/${matchOrderMap.params.restaurantId}/${matchOrderMap.params.mapId}`
			: `/order/${matchOrderId?.params?.id}`
		return <Redirect to={menuPath} />
	}

	const confirmationPath = matchOrderMap
		? `/order/${matchOrderMap.params.restaurantId}/${matchOrderMap.params.mapId}/confirmation`
		: `/order/${matchOrderId.params.id}/confirmation`

	const menuPath = matchOrderMap
		? `/order/${matchOrderMap.params.restaurantId}/${matchOrderMap.params.mapId}`
		: `/order/${matchOrderId?.params?.id}`

	function handleBack() {
		history.push(menuPath, { openCart: true })
	}

	function handleSuccess(orderId) {
		clearCart()
		history.push(`${confirmationPath}/${orderId}`)
	}

	return (
		<div className={styles.page}>
			<CheckoutForm
				restaurantId={restaurantId}
				cartItems={cartItems}
				total={total}
				checkoutConfig={checkoutConfig}
				onBack={handleBack}
				onSuccess={handleSuccess}
			/>
		</div>
	)
}

export default function CheckoutPage({ data, customerOrderingScopes }) {
	const checkoutConfig = customerOrderingScopes?.checkoutConfig

	if (customerOrderingScopes && !customerOrderingScopes.hasOrderingScopes) {
		return (
			<div className={styles.page}>
				<p>{customerOrderingScopes.checkoutBlockedReason}</p>
			</div>
		)
	}

	return (
		<OrderingProvider restaurantId={data?._id}>
			<CheckoutContent restaurantId={data?._id} checkoutConfig={checkoutConfig} />
		</OrderingProvider>
	)
}
